import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import ROUTES from '~/shared/constants/routes.const'
import checklistStyles from '~/checklist/styles/Checklist.module.css'
import useToggleBase from '~/hooks/useToggleBase'
import { HighlightIds } from '~/checklist/constants'
import { noop } from '~/onboarding/utils/misc.utils'
import { selectHighlightedItem } from '~/redux/slices/dashboard'
import { selectPreviewSite } from '~/redux/slices/ui'
import { selectUserCanAccessHomebaseViaNavLinks } from '~/redux/slices/user'
import { useAppSelector } from '~/redux/hooks'
import { useGetBaseSrcKey } from '~/hooks/useGetBaseSrcKey'

export const SpaceButton = (): React.ReactElement => {
  const { t } = useTranslation('homebase')
  const router = useRouter()
  const previewSite = useAppSelector(selectPreviewSite)
  const { isLoading: isHomebaseAccessStatusLoading } = useAppSelector(selectUserCanAccessHomebaseViaNavLinks)
  const toggleBase = useToggleBase()
  const baseSrcKey = useGetBaseSrcKey()
  const highlightedItem = useAppSelector(selectHighlightedItem)
  const highlightClass = highlightedItem === HighlightIds.EXPLORE_SPACE ? checklistStyles['highlight'] : ''

  const handleClick = (): void => {
    if (previewSite) {
      router.push(ROUTES.REGISTER)
      return
    }
    if (isHomebaseAccessStatusLoading) {
      noop()
    } else {
      toggleBase()
    }
  }

  return (
    <button
      className={`flex items-center justify-center ${highlightClass}`}
      data-test-id="topbar-space"
      id="explore-space"
      onClick={handleClick}
    >
      <ResponsiveImage
        alt={t('navbarIcon')}
        height={40}
        imageClassName="w-8 md:w-10"
        loading="eager"
        srcKey={baseSrcKey}
        width={36}
      />
    </button>
  )
}
